<template>
  <v-container>
    <v-layout row justify-center>
      <v-flex xs12>
        <Users v-if="views.usersView" key="users" />
        <Archive v-if="views.archiveView" key="archive" />
      </v-flex>
    </v-layout>
    <SignIn v-model="views.signInView" :trainingSessions="signInSession" key="signin" />
    <CreateCard v-model="views.editView" />
    <CreateCard v-model="views.createView" />

    <v-layout row wrap key="transition">
      <v-flex v-for="(session, index) in activeSessions" :key="index + 0" sm6 xs12>
        <TrainingCard
          v-if="views.cardView"
          :trainingSessions="session"
          @update="updateSession(session)"
          @compute-sessions="computeNoSessions"
          key="card"
        />
      </v-flex>
    </v-layout>
    <NoSessions v-if="computeNoSessions() && views.cardView" key="no-sessions" />

    <v-btn
      v-if="!computeNoSessions() && views.cardView"
      fab
      bottom
      right
      fixed
      color="secondary"
      @click="create"
    >
      <v-icon large>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import router from "@/router/router";

import {
  Archive,
  TrainingCard,
  SignIn,
  CreateCard,
  NoSessions
} from "@/components/training";

export default {
  name: "Training",

  components: {
    Archive,
    TrainingCard,
    SignIn,
    CreateCard,
    NoSessions
  },

  data() {
    return {
      selectedSession: {},
      activeSessions: []
    };
  },

  mixins: [LoginCheck],

  computed: {
    ...mapGetters({
      allSessions: "training/getAllSessions",
      views: "training/getViews",
      loading: "app/isLoading",
      signInSession: "training/getSignInSession"
    })
  },

  mounted() {
    this.$store.dispatch("training/getAllSessions", {
      rowsPerPage: -1,
      active: true
    });
    this.computeNoSessions();
  },

  destroyed() {
    this.setView({
      cardView: true,
      signInView: false,
      archiveView: false,
      createView: false
    });
  },

  watch: {
    allSessions() {
      this.getActiveSessions();
      this.computeNoSessions();
    }
  },

  methods: {
    ...mapMutations({
      setView: "training/setViews"
    }),
    updateSession(session) {
      this.setView({
        cardView: false,
        signInView: true
      });
      router.push({
        name: "training",
        params: { component: "sign-in", session: session._id }
      });
      this.selectedSession = session.trainingSession;
      this.selectedSession._id = session._id;
      this.$store.commit("training/setSignInSession", this.selectedSession);
    },
    create() {
      router.push({ name: "training", params: { component: "create" } });
      this.setView({
        cardView: false,
        signInView: false,
        archiveView: false,
        createView: true
      });
    },
    getActiveSessions() {
      let active = [];
      this.allSessions.forEach(session => {
        if (session.trainingSession.active) active.push(session);
      });
      this.activeSessions = active;
    },
    computeNoSessions() {
      var show = true;
      this.allSessions.forEach(item => {
        if (item.trainingSession.active) {
          show = false;
          return show;
        }
      });
      return show;
    }
  }
};
</script>

<style></style>
